export enum TafaceCompanyTypeEnum {
  UNI = 'UNI',
  SA = 'SA',
  SRL = 'SRL',
  SAS = 'SAS',
  OTR = 'OTR',
}
